import { Optional } from "./types";

export function getValueOrEmpty(value: Optional<string>) {
  const valueToReturn = value?.trim() !== "" ? value : null;
  return valueToReturn ?? "-";
}
